import { createRoot, render } from '@wordpress/element';
import { MainSettingsSection } from './components/main-settings-section';
import { setupHooks } from './setup-hooks';

setupHooks();

const el = document.getElementById('tab_conditional_pricing_page');

if (el) {
	if (typeof createRoot === 'function') {
		const root = createRoot(el);
		root.render(<MainSettingsSection />);
	} else {
		render(<MainSettingsSection />, el);
	}
}
